import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { CloseIcon } from 'tdesign-icons-react';
import { Loading } from 'tdesign-react';

import { AddFilled, VoiceIcon } from '@/components/icon';
import { Voice } from '@/interface/aigc';
import AigcVoiceDialog from '@/material/AigcVoiceDialog';
import { AudioPlayer } from '@/material/form-upload/core/player/audio/audio';

import styles from './index.module.less';

interface IProps {
  onChange: (key?: Voice) => void;
  value?: Voice;
  disabled: boolean;
  loading?: boolean;
}

const VoicePlay: React.FC<IProps> = (props) => {
  const { value, disabled = false, loading = false, onChange } = props;
  const { voiceId: id = '', voiceName: name = '未命名', url = '' } = value || {};
  const [data, setData] = useState<Voice | undefined>();
  const [visible, setVisible] = useState(false);
  const audioRef = useRef<any>(null);

  useEffect(() => {
    setData(value);
  }, [value]);

  const handleClose = () => {
    setVisible(false);
  };

  const handleConfirm = (src?: Voice) => {
    if (src) {
      onChange(src);
    } else {
      onChange();
    }
    handleClose();
  };

  const openDialog = () => {
    if (disabled) {
      return;
    }
    setVisible(true);
  };

  const handlePlay = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    audioRef?.current?.triggerPlay();
  };

  const handleDelete = () => {
    if (disabled) {
      return;
    }
    onChange();
  };

  return (
    <Loading loading={loading} size='small'>
      {id ? (
        <div className={styles.container}>
          <div className={styles.left} onClick={openDialog}>
            <div className={styles.player} onClick={e => handlePlay(e)}>
              <AudioPlayer url={url} size={24} playRef={audioRef} />
            </div>
            {name}
          </div>
          <div className={classNames(styles.right, { [styles.disabled]: disabled })} onClick={handleDelete}>
            <CloseIcon size={16} color='#FFFFFF66' />
          </div>
        </div>
      ) : (
        <div className={classNames(styles.empty, { [styles.disabled]: disabled })} onClick={openDialog}>
          <div className={styles.left}>
            <VoiceIcon style={{ width: 24, height: 24 }} />
            点击选择语音包
          </div>
          <AddFilled style={{ width: 16, height: 16 }} />
        </div>
      )}
      <AigcVoiceDialog
        data={data}
        visible={visible}
        onClose={handleClose}
        onConfirm={handleConfirm}
      />
    </Loading>
  );
};

export default VoicePlay;
